import { rhythmStats } from '@/mocks/homeData';

export default function RhythmBand() {
  return (
    <section className="w-full bg-accent-500">
      <div className="w-full px-4 py-10 md:px-10 md:py-14">
        <div className="grid grid-cols-2 gap-y-8 lg:grid-cols-4">
          {rhythmStats.map((stat, index) => (
            <div
              key={stat.label}
              className={`px-2 md:px-6 ${
                index !== 0 ? 'lg:border-l lg:border-foreground-950/15' : ''
              }`}
            >
              <p className="font-heading text-3xl font-bold tabular-nums tracking-tight text-foreground-950 md:text-4xl">
                {stat.value}
                {stat.unit && (
                  <span className="ml-1 text-base font-normal text-foreground-800">{stat.unit}</span>
                )}
              </p>
              <p className="mt-2 text-xs tracking-wider text-foreground-800 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}